export const enum TrackerName {
  jointTracker = 'jointTracker',
  marketingSite = 'marketingSite',
}
